module.exports = __webpack_public_path__ + "85d4357154762740585e123e995421b7.svg";